import { useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';

import { GeneralWebSocketSubscriptionTypes } from 'constants/app';
import { getGeneralWsEnabled } from 'redux/modules/appConfigs/selectors';
import { getIsConnectedGeneral, getSubscribeToGeneralMessages } from 'redux/modules/webSocket/selectors';

export default function MarketGraphChartInjection() {
  const {
    marketId,
    selectionId,
    handicap = 0
  } = useParams<{ marketId: string; selectionId: string; handicap: string }>();

  const subscribeGeneralWebSocketMessages = useSelector(getSubscribeToGeneralMessages);
  const isConnectedGeneralWebSocket = useSelector(getIsConnectedGeneral);
  const generalWsEnabled = useSelector(getGeneralWsEnabled);

  const generalWsDataRef = useRef<{
    isSubscriptionAvailable: boolean;
    subscribeGeneralWebSocketMessages: (<F>(params: F) => void) | null;
  }>({
    isSubscriptionAvailable: false,
    subscribeGeneralWebSocketMessages: null
  });

  const isSubscriptionAvailable =
    isConnectedGeneralWebSocket && generalWsEnabled && !!subscribeGeneralWebSocketMessages;

  generalWsDataRef.current = { isSubscriptionAvailable, subscribeGeneralWebSocketMessages };

  useEffect(() => {
    if (isSubscriptionAvailable) {
      subscribeGeneralWebSocketMessages({
        [GeneralWebSocketSubscriptionTypes.marketGraphs]: {
          subscribe: true,
          marketId,
          selectionId,
          handicap: +handicap
        }
      });
    }
  }, [isSubscriptionAvailable, marketId, selectionId, handicap]);

  useEffect(() => {
    return () => {
      if (
        generalWsDataRef.current.isSubscriptionAvailable &&
        generalWsDataRef.current.subscribeGeneralWebSocketMessages
      ) {
        generalWsDataRef.current.subscribeGeneralWebSocketMessages({
          [GeneralWebSocketSubscriptionTypes.marketGraphs]: { subscribe: false }
        });
      }
    };
  }, []);

  return null;
}
